import { Link } from 'react-router-dom';

/** Site footer with legal links, shown under the main content on every page. */
export function Footer() {
  const year = new Date().getUTCFullYear();
  return (
    <footer className="border-t border-tile-edge bg-[#fffdf6]/95">
      <div className="mx-auto flex w-full max-w-content flex-col items-center gap-2 px-4 py-4 text-xs text-stone-500 sm:flex-row sm:justify-between">
        <span>© {year} Scrabble Daily</span>
        <nav className="flex items-center gap-4" aria-label="Footer">
          <Link to="/about" className="hover:text-stone-800">
            About
          </Link>
          <Link to="/privacy" className="hover:text-stone-800">
            Privacy
          </Link>
          <Link to="/terms" className="hover:text-stone-800">
            Terms
          </Link>
        </nav>
      </div>
    </footer>
  );
}
